<template>
  <div class="news" id="news">
    <Scrollama @step-enter="stepEnterHandler">
      <div class="step1" data-step="a">
        <div class="head bg-img-maintain">
          <div class="title animation" >关于沈阳蓝智科技有限公司</div>
          <div class="content animation">提供企业内外部资源协同整合管理的平台，帮助企业更好管理</div>
<!--          <el-button class="btn animation">查看更多</el-button>-->
        </div>
      </div>
      <div class="step2" data-step="b">
          <div class="qualification-content" >
            <div class="fnt-32-bold animationToBottom">
              资质荣誉
            </div>
            <div class="animation" v-show="show1">
              <div class="qualification-content-child">
                <img v-for="(item, index) in dataList" :key="index"
                     src="../../../static/images/aboutUs/qualificationHonor/icon1.png"/>
              </div>
            </div>
          </div>
      </div>
      <div class="step3" data-step="c">
        <footer-item class="animation"></footer-item>
      </div>
    </Scrollama>
  </div>
</template>
<script>
import Scrollama from 'vue-scrollama'
import footerItem from '../../home/components/footer-item'
export default {
  components: {
    Scrollama,
    footerItem
  },
  data () {
    return {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      dataList: [1, 2, 3, 4, 5, 6, 7, 8]
    }
  },
  methods: {
    stepEnterHandler ({element, index, direction}) {
      switch (element.className) {
        case 'step2':
          this.show1 = true
          break
        case 'step3':
          this.show2 = true
          break
        case 'step4':
          this.show3 = true
          break
        case 'step5':
          this.show4 = true
          break
      }
    }
  },
  mounted: function () {
  }
}
</script>
<style scoped lang="less">
.news{
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  div{
    //一级标题
    .first-level-title{
      font-size: 42px;
      font-weight: 500;
      color:#323232;
    }
    //背景图宽度保持不变类
    .bg-img-maintain{
      background-size: cover !important;
      background-position: center !important;
    }
    .head{
      height: 71vh;
      width: calc(100% - 100px);
      /*border:1px solid rgba(0, 0, 0, 0);*/
      display: flex;
      flex-direction: column;
      align-items: baseline;
      padding-left: 100px;
      background: url("../../../static/images/aboutUs/banner.png") no-repeat;
      .title{
        font-size: 52px;
        opacity: 0;
        margin-top: 25vh;
        font-weight: 500;
        color: #fff;
      }
      .content{
        font-size: 32px;
        opacity: 0;
        margin-top:40px;
        color: #E6E9F3;
      }
      .el-button {
        width: 200px;
        height: 60px;
        margin-top: 100px;
        color: #E6E9F3;
        background-color: transparent;
        border: 1px solid #E6E9F3;
        font-size: 18px;
      }
    }
    .qualification-content {
      min-height: 1100px;
      width: 100%;
      background: url("../../../static/images/aboutUs/qualificationHonor/bg.png") no-repeat;
      background-size: 100% 100%;
      .fnt-title {
        padding: 10px 0;
        font-weight: 700;
      }
      &-child{
        width: calc(100% - 200px);
        /*margin-left: 100px;*/
        text-align: left;
        padding: 100px;
        display: flex;
        /*position: absolute;*/
        flex-wrap: wrap;
        justify-content: space-between;
        /*justify-content: space-between;*/
        img {
          height: 520px;
          width: 428px;
        }
        img:hover {
          transform: scale(1.15);
        }
      }
      /deep/ .el-pagination button:disabled, /deep/ .el-pager li, /deep/ .el-pagination button {
        color: #8c939d;
        background: transparent;
        font-size: 24px;
      }
      /deep/ .el-pager li.active {
        color: #003f92;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs/qualificationHonor/index.vue